import styled from 'styled-components';
import { outlineGray, primaryColor, primaryColorDark } from '../../../../config/colors';

import { Section } from '../../styles';

export const StyledSection = styled(Section)``;

export const ComparisonLane = styled.div`
  width: 40px;
  position: absolute;
  left: calc(100% - 9px);
  top: 0px;
  display: flex;
  flex-direction: column;
  z-index: 1;
  height: 100%;
`;

export const ComparatorButton = styled.div`
  background-color: ${primaryColor};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
  user-select: none;

  box-sizing: border-box;
  transition: border-color 0.3s ease-out;
  border: 2px solid ${outlineGray};
  cursor: pointer;
  position: relative;

  &:hover {
    border-color: ${primaryColorDark};
  }

  & label {
    font-size: 19px;
    display: inline-block;
    width: 100%;
    color: white;
    position: relative;
    cursor: inherit;
    transition: font-size 0.3s ease-out;
  }

  & label.left-arrow {
    position: relative;
    top: 9px;
    left: 15px;
  }

  & label.right-arrow {
    transform: rotate(180deg);
    position: relative;
    top: -9px;
    left: -16px;
  }

  &:hover label {
    font-size: 16px;
  }

  &.isHeader {
    margin-top: 4px;
  }

  &.isRegularComparisonCut {
    margin-top: 75px;
  }

  &.isRegularComparisonCut:first-child {
    margin-top: 95px;
  }
`;
